import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Clock } from 'lucide-react';
import { blogPosts } from './blog/posts';
export function LatestBlogPosts() {
  // Get the 3 most recent posts
  const recentPosts = blogPosts.slice(0, 3);
  return <section className="py-20 bg-brand-50/30" data-id="element-2791" data-mp="1fsyujdegs870">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2792" data-mp="1arj93k8djzo3">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between mb-12 gap-4" data-id="element-2793" data-mp="1au5ilpetsp8y">
          <div data-id="element-2794" data-mp="n41p4avcq5vo">
            <h2 className="text-3xl sm:text-4xl font-black text-slate-900 mb-4" data-id="element-2795" data-mp="i3docxhbmao9">
              Latest from Our Blog
            </h2>
            <p className="text-lg text-slate-600 max-w-2xl" data-id="element-2796" data-mp="w3y6drfew2gp">
              Read our latest articles on nutrition, food marketing, and how to
              make smarter grocery choices.
            </p>
          </div>
          <Link to="/blog" className="inline-flex items-center text-brand-600 font-bold hover:text-brand-700 transition-colors" data-id="element-2797" data-mp="27gh515rv23mu">
            
            View All Posts <ArrowRight className="w-4 h-4 ml-2" data-id="element-2798" data-mp="2sfxkaqkldts6" />
          </Link>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-2799" data-mp="2xeh8kxmnrhnp">
          {recentPosts.map(post => <Link key={post.slug} to={`/blog/${post.slug}`} className="group bg-white rounded-2xl border border-slate-100 shadow-sm hover:shadow-xl transition-all duration-300 overflow-hidden flex flex-col" data-id="element-2800" data-mp="2xgllg52jbr04">
            
              <div className="relative h-48 overflow-hidden" data-id="element-2801" data-mp="29owp8dmleidw">
                <img src={post.image} alt={post.imageAlt} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-2802" data-mp="29qhfhr1vjf5y" />
              
                <span aria-hidden="true" className="pointer-events-none absolute bottom-2 right-2 select-none rounded-full bg-white/70 px-2 py-0.5 text-[10px] font-black tracking-tight backdrop-blur-sm" data-id="element-2803" data-mp="2ipcrjjrlnjh6">
                
                  <span className="text-slate-900/70" data-id="element-2804" data-mp="1q0e4c88mdr50">Intelli</span>
                  <span className="text-brand-600/80" data-id="element-2805" data-mp="1uz8lz6uup9nj">Eats</span>
                </span>
              </div>
              <div className="p-6 flex flex-col flex-grow" data-id="element-2806" data-mp="2ya4n9j71gpt0">
                <div className="flex items-center gap-3 mb-3" data-id="element-2807" data-mp="2tbuo6xi71524">
                  <span className="px-2.5 py-1 rounded-full bg-brand-50 text-brand-700 text-xs font-bold tracking-wider uppercase" data-id="element-2808" data-mp="2tbbge9m9bx1t">
                    {post.category}
                  </span>
                  <span className="flex items-center text-xs text-slate-400" data-id="element-2809" data-mp="332xrm5ylhw4k">
                    <Clock className="w-3 h-3 mr-1" data-id="element-2810" data-mp="2fba8493nxncb" />
                    {post.readTime}
                  </span>
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-3 group-hover:text-brand-600 transition-colors line-clamp-2" data-id="element-2811" data-mp="2aetfb1liqksw">
                  {post.title}
                </h3>
                <p className="text-slate-600 text-sm leading-relaxed mb-4 line-clamp-3 flex-grow" data-id="element-2812" data-mp="2jcvr8c6sixuy">
                  {post.excerpt}
                </p>
                <span className="inline-flex items-center text-sm font-semibold text-brand-600 group-hover:text-brand-700 mt-auto" data-id="element-2813" data-mp="3ut2hul91dddp">
                  Read Article{' '}
                  <ArrowRight className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform" data-id="element-2814" data-mp="76je362lofxa" />
                </span>
              </div>
            </Link>)}
        </div>
      </div>
    </section>;
}